import React from "react";
import "./contactUsCard.scss";
import { Button, Skeleton } from "@mui/material";

const ContactUsCardSkeleton = ({ replied = true }) => {
  return (
    <div className="contact-us-card">
      <div className="create-at">
        <Skeleton animation="wave">
          <p>Tue 25, Apr 2023</p>
        </Skeleton>
      </div>

      <div className="customer-name">
        <Skeleton animation="wave">
          <p>Demo</p>
        </Skeleton>
      </div>
      <div className="customer-email">
        <Skeleton animation="wave">
          <p>demo@gmail.com</p>
        </Skeleton>
      </div>
      <div className="customer-phone-no">
        <Skeleton animation="wave">
          <p>1234567890</p>
        </Skeleton>
      </div>
      <div className="customer-message">
        <div className="title">Message</div>
        <div className="content">
          <Skeleton animation="wave" width="100%" />
        </div>
      </div>
      <div className="replied">
        {replied ? (
          <Skeleton animation="wave">
            <Button>Reply</Button>
          </Skeleton>
        ) : (
          <div className="replied-at">
            <Skeleton animation="wave">
              <p>- Tue 25, Apr 2023</p>
            </Skeleton>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactUsCardSkeleton;
